<template>
    <div class="upload-opus">

        <div class="upload-con">
            <div class="upload-suss-title">
                <p class="title">很抱歉！您来晚了</p>
                <p>作品上传已截至</p>
            </div>
        </div>

        <!--
        <div class="upload-opus-con" v-if="!uploadSussShow">
            <div class="upload-opus-title">上传作品</div>

            <el-form :model="uploadListForm" :rules="rules" ref="uploadListForm" class="demo-dynamic upload-list">
                <el-form-item label="姓名(请填写参赛人信息)" prop="name" class="form-con">
                    <el-input v-model="uploadListForm.name" placeholder="请输入姓名"></el-input>
                </el-form-item>

                <el-form-item label="昵称（将展示在个人作品页面）" prop="nickname" class="form-con">
                    <el-input v-model="uploadListForm.nickname" placeholder="展示昵称"></el-input>
                </el-form-item>

                <el-form-item prop="email" label="邮箱" class="form-con">
                    <el-input v-model="uploadListForm.email" placeholder="请输入邮箱"></el-input>
                </el-form-item>

                <el-form-item class="form-con-address">
                    <div class="img-title"><span>*</span>通讯地址</div>
                    <div class="address-con">
                        <el-select v-model="item.pid" :placeholder="item.name"
                                   value-key="pid"
                                   v-for="(item, index) in addressList"
                                   :key="index"
                                   @change="changeAddress(item.pid, index)"
                        >
                            <el-option
                                    v-for="opt in item.option"
                                    :key="opt.pid"
                                    :label="opt.region"
                                    :value="opt">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="addressErr">{{addressErr}}</div>
                </el-form-item>

                <el-form-item prop="detail_address" class="form-con">
                    <el-input v-model="uploadListForm.detail_address" placeholder="请输入详细地址"></el-input>
                </el-form-item>

                <div class="imageUrl-list-con">
                    <div class="img-title"><span>*</span>上传作品（支持PNG/JPEG格式，5M内）</div>
                    <el-form-item class="main-pic" v-for="(item, index) in picUrlList" :key="index">
                        <div class="picUrl-con">
                            <div class="input-img-con">
                                <label class="chooseInput">
                                    <input type='file' name='file' :ref="item.style" accept='.jpg,.png,.jpeg'
                                           class='chooseInput' style="display: none"
                                           @change="getPicUrl($event,index)"
                                    >
                                    <i class="el-icon-plus"></i>
                                </label>
                                <div class="img-con" v-if="item.picUrl != ''">
                                    <img :src="item.picUrl" alt="">
                                    <i class="el-icon-delete clear-img" @click="clearPicUrl(item.style, index)"></i>
                                </div>
                            </div>
                            <div class="img-text">{{ item.text }}</div>
                        </div>
                    </el-form-item>
                    <div class="picUrlErr" v-if="picUrlErr!=''">{{picUrlErr}}</div>
                </div>

                <el-form-item label="作品名称" prop="work_name" class="form-con">
                    <el-input v-model="uploadListForm.work_name" placeholder="请输入作品名称"></el-input>
                </el-form-item>


                <el-form-item label="创意思路描述" prop="work_description" class="form-con description-con">
                    <el-input v-model="uploadListForm.work_description" placeholder="字数不多于200字" :rows="10"
                              type="textarea"></el-input>
                    <div class="descriptionLength">{{descriptionLength}}/200</div>
                </el-form-item>
                <el-form-item>
                    <div class="match-button " @click="toUploadOpus('uploadListForm')">
                        <span :class="{ 'upload' : toUpload}">上传作品</span>
                    </div>
                </el-form-item>
            </el-form>

        </div>

        <div class="upload-con" v-if="uploadSussShow">
            <div class="upload-suss-title">
                <p class="title">恭喜你，报名成功！</p>
                <p>您的作品将在工作人员审核通过后显示！</p>
            </div>
            <div class="upload-suss-but">
                <div class="upload-but"
                     v-for="(item, index) in uploadSussBut"
                     :class="{'active': uploadSussNum == index}"
                     @click="toRouterCom(index)"
                >
                    {{ item }}
                </div>
            </div>
        </div>-->
    </div>
</template>

<script>
    export default {
        name: "uploadOpus",
        data() {
            return {
                uploadListForm: {
                    name: '', //姓名
                    nickname: '', //昵称
                    email: '',
                    province: '',
                    pid: '',
                    city: '',
                    cid: '',
                    district: '',
                    did: '',
                    detail_address: '', //详细地址
                    work_name: '',  //作品名称
                    work_description: '', //创意思路描述
                    main_pic: {}, //效果图
                    front_pic: {}, //正面图
                    side_pic: {},  //侧视图
                    top_pic: {},  //顶视图
                    session: '',  //登录凭证
                    OCSESSID: '', //登录凭证
                    work_id: ''
                },
                rules: {
                    name: [
                        {required: true, message: '请填写参赛人信息', trigger: 'blur'},
                    ],
                    nickname: [
                        {required: true, message: '请填写昵称', trigger: 'blur'}
                    ],
                    email: [
                        {required: true, message: '请输入邮箱地址', trigger: 'blur'},
                        {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
                    ],
                    detail_address: [
                        {required: true, message: '请输入详细地址', trigger: 'blur'}
                    ],
                    work_name: [
                        {required: true, message: '请输入作品名称', trigger: 'blur'}
                    ],
                    work_description: [
                        {required: true, message: '请填写创意思路', trigger: 'blur'},
                        {min: 1, max: 200, message: '字数不多于200字', trigger: 'blur'}
                    ]
                },
                picUrlList: [
                    {text: '带场景的3D效果图', picUrl: '', style: 'main_pic', file: {}, src: ''},
                    {text: '飞船3D正面图', picUrl: '', style: 'front_pic', file: {}, src: ''},
                    {text: '飞船3D侧面图', picUrl: '', style: 'side_pic', file: {}, src: ''},
                    {text: '飞船3D顶面图', picUrl: '', style: 'top_pic', file: {}, src: ''}
                ],
                picSize: '',
                picUrlErr: '',
                addressList: [
                    {name: '请选择省份', value: '', option: {}, pid: {}, style: 'province', idStyle: 'pid'},
                    {name: '请选择城市', value: '', option: {}, pid: {}, style: 'city', idStyle: 'cid'},
                    {name: '请选择城区', value: '', option: {}, pid: {}, style: 'district', idStyle: 'did'},
                ],
                pid: 0,
                level: 0,
                addressErr: '',
                uploadSussBut: ['进入我的作品页面', '返回首页'], //上传成功后提示框
                uploadSussNum: 0,
                uploadSussShow: false,
                // 页面级变量
                pageRecord: {
                    title: 'precision25周年',
                    module: 'precision25周年',
                    category1: '上传作品',
                },
                toUpload: false,
                descriptionLength: 0,
                rootName: '',
                myWorkList: {},
            }
        },
        mounted() {
            if (!this.$tool.isLogin()) {
                this.$router.push({path: '/login'});
            }
            this.myWorkList = this.$tool.getLS('myWorkList', 1)
            this.getUserInfo();

            //回填信息 作品作者
            if (this.myWorkList) {
                this.getAuthorData();
            } else {
                //获取地区级联
                this.getRegionsData(0, 0);
            }
        },
        computed: {
            //该计算属性返回要监视的对象属性值
            description() {
                return this.uploadListForm.work_description;
            }
        },
        watch: {
            //开始监听返回该对象属性值计算属性
            description: function (newVal, oldVal) {
                if (newVal) {
                    this.descriptionLength = newVal.length
                }
            },
        },
        methods: {
            getPicUrl(event, index) {
                let maxSize = 1024 * 5;
                let fileSize = event.target.files[0].size / 1024;
                console.log('uploadFileSize', fileSize)
                if (fileSize > maxSize) {
                    this.$alert('上传文件请小于5M', {
                        confirmButtonText: '确定',
                        callback: action => {
                        }
                    });
                    event.target.value = '';
                    return;
                }
                let num = 0
                this.toUpload = false;
                this.picUrlErr = '';
                let file = event.target.files;
                console.log(file[0])
                this.picUrlList[index].file = file[0]
                this.picUrlList[index].picUrl = this.getObjectURL(file[0]);
                //上传了4张图片后 上传按钮 才能点击
                this.picUrlList.forEach(item => {
                    if (item.picUrl != '') {
                        num++
                    }
                })
                if (num == 4) {
                    this.toUpload = true;
                }
                this.getUploadImg(index)
                event.target.value = '';
            },
            getObjectURL(file) {
                var url = null;
                if (window.createObjectURL != undefined) { // basic
                    url = window.createObjectURL(file);
                } else if (window.URL != undefined) { // mozilla(firefox)
                    url = window.URL.createObjectURL(file);
                } else if (window.webkitURL != undefined) { // webkit or chrome
                    url = window.webkitURL.createObjectURL(file);
                }
                return url;
            },
            toUploadOpus(formName) {
                this.picUrlErr = '';
                this.addressErr = ''
                let upload = true;
                //判断是否 上传图片
                this.picUrlList.forEach(item => {
                    if (item.src == '') {
                        this.picUrlErr = '请上传作品图片';
                        upload = false;
                    }
                })
                //判断是否填写省市县
                this.addressList.forEach(item => {
                    if (Object.keys(item.pid).length == 0) {
                        console.log(item.pid)
                        this.addressErr = "请选择通讯地址";
                        upload = false;
                    }
                })

                this.$refs[formName].validate((valid) => {
                    if (valid && upload) {
                        this.toUpload = true;
                        //图片file
                        this.picUrlList.forEach(item => {
                            this.uploadListForm[item.style] = item.src
                        })

                        //address
                        if (this.myWorkList) {
                            this.addressList.forEach(item => {
                                this.uploadListForm[item.style] = item.value
                            })
                        } else {
                            this.addressList.forEach(item => {
                                this.uploadListForm[item.style] = item.pid.region
                                this.uploadListForm[item.idStyle] = item.pid.pid
                            })
                        }

                        console.log(this.uploadListForm)
                        this.uploadListForm.session = this.$tool.isLogin().session;
                        this.uploadListForm.OCSESSID = this.$tool.isLogin().OCSESSID;

                        //修改
                        if (this.myWorkList) {
                            this.uploadListForm.work_id = this.$tool.getLS('userWorkId', 1)
                        }
                        console.log('上传参数', this.uploadListForm)
                        //是否提交弹框
                        this.$confirm('<p>提交后将无法修改，</p><p>请确认您提交的信息准确无误！</p>', {
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '确认提交',
                            cancelButtonText: '取消'
                        })
                            .then(() => {
                                console.log('提交')
                                //确认提交  上传到提交接口
                                this.$api.getUpload(this.uploadListForm)
                                    .then(res => {
                                        console.log('上传成功', res)
                                        if (res.msg == '成功') {
                                            this.uploadSussShow = true;

                                            // 上传成功埋点
                                            this.gioAction('precision25thart_uploadsuccess', {
                                                'email': this.uploadListForm.email,
                                                'userName': this.uploadListForm.name,
                                                'phoneNumber': this.loginInfo.mobile,
                                            })
                                        } else {
                                            this.$alert(res.msg, {
                                                confirmButtonText: '确定',
                                                callback: action => {
                                                }
                                            });
                                        }
                                    })
                            })
                            .catch(action => {
                                console.log('取消提交')
                            });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
            clearPicUrl(style, index) {

                this.toUpload = false;
                this.picUrlList[index].picUrl = '';
                // this.$refs[style].value = '';
                this.picUrlList[index].file = {};
            },
            //地区级联 切换数据 获取县市级联数据
            changeAddress(pid, level) {
                this.addressErr = "";
                if (level < 2) {
                    this.addressList.forEach((item, index) => {
                        if (index >= level + 1) {
                            this.addressList[index].option = {};
                            this.addressList[index].pid = {};
                        }
                    })
                }
                this.pid = pid.pid;
                this.level = level + 1;
                if (this.level < 3) {
                    this.getRegionsData(this.pid, this.level)
                }
            },
            //获取省市级联菜单
            getRegionsData(pid, level) {
                console.log(this.addressList)
                this.$api.getRegions(pid, level)
                    .then(res => {
                        this.addressList[level].option = res.data;
                        console.log(this.addressList)
                    })
                    .catch((e) => {
                        console.log(e)
                    });
            },
            //上传图片
            getUploadImg(index) {
                console.log('dd')
                const loading = this.$loading({
                    lock: true,
                    text: '正在上传，请稍后...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let formData = new FormData();
                formData.append("file", this.picUrlList[index].file);
                formData.append("session", this.$tool.isLogin().session);
                formData.append("OCSESSID", this.$tool.isLogin().OCSESSID);
                this.$api.getUpImg(formData)
                    .then(res => {
                        console.log(res)
                        this.picUrlList[index].src = res.data.src
                        loading.close();
                    })
                    .catch((e) => {
                        console.log(e)
                        loading.close();
                    });
            },
            //上传成功后提示框
            toRouterCom(index) {
                this.uploadSussNum = index;
                if (index == 0) {
                    //进入我的作品页面
                    this.getMyWorkId()
                } else {
                    //返回首页
                    this.$router.push({path: '/'});
                }
            },
            //获取我的作品 work_id
            getMyWorkId() {
                this.$api.getMyWork(this.$tool.isLogin().session, this.$tool.isLogin().OCSESSID)
                    .then(res => {
                        if (res.data.work_id) {
                            this.$tool.setLS('workId', res.data.work_id, 1)
                            //登录这者 workId 用来判断审核状态的显隐
                            this.$tool.setLS('userWorkId', res.data.work_id, 1)
                            console.log('我的作品的id', this.$tool.getLS('workId', 1))
                            setTimeout(() => {
                                this.$router.push({path: '/opusInfo', query: {id: res.data.work_id}});
                            }, 300)
                        }
                    })
                    .catch((e) => {
                    });
            },
            //获取用户信息
            async getUserInfo() {
                if (this.$tool.isLogin()) {
                    this.isLoginShow = true;
                    this.loginInfo = await this.$tool.getUserInfo();
                    console.log(this.loginInfo)
                    this.uploadListForm.email = this.loginInfo.email;
                    this.uploadListForm.name = this.loginInfo.name;
                }
            },
            //修改作品的信息回填
            async getAuthorData() {
                let auth = await this.$api.getAuthor(this.$tool.isLogin().session, this.$tool.isLogin().OCSESSID);
                this.getRegionsData(auth.data.pid, 0)
                this.getRegionsData(auth.data.pid, 1)
                this.getRegionsData(auth.data.cid, 2)
                Object.keys(auth.data).forEach((key, index) => {
                    this.uploadListForm[key] = auth.data[key]
                })
                //回填通讯地址
                this.addressList[0].value = auth.data.province
                this.addressList[0].pid = {pid: auth.data.pid, region: auth.data.province};
                this.addressList[1].value = auth.data.city
                this.addressList[1].pid = {pid: auth.data.cid, region: auth.data.city};
                this.addressList[2].value = auth.data.district
                this.addressList[2].pid = {pid: auth.data.did, region: auth.data.district};

                console.log(this.addressList)
                if (this.myWorkList) {
                    this.uploadListForm.nickname = this.myWorkList.nickname;
                    this.uploadListForm.work_description = this.myWorkList.description;
                    this.uploadListForm.work_name = this.myWorkList.name;
                    this.myWorkList.images.forEach((item, index) => {
                        this.picUrlList[index].picUrl = item.url
                        this.picUrlList[index].src = item.url
                    })

                    this.toUpload = true;
                }
            },
        }
    }
</script>
<style scoped lang="less">
    @import "../assets/css/UploadOpus/pc";
    @import "../assets/css/UploadOpus/wap";
</style>
<style>
    .el-loading-mask{
        font-size: 32px;
    }
    @media (max-width: 992px) {
        .el-loading-mask{
            font-size: 80px;
        }
        .el-loading-mask .el-loading-spinner .el-loading-text{
            font-size: 22px;
        }
    }
</style>
